import Creator1 from "@/assets/gifs/creator-shield/C1.gif";
import Creator2 from "@/assets/gifs/creator-shield/C2.gif";
import Creator3 from "@/assets/gifs/creator-shield/C3.gif";
import Creator4 from "@/assets/gifs/creator-shield/C4.gif";
import Creator5 from "@/assets/gifs/creator-shield/C5.gif";
import Creator6 from "@/assets/gifs/creator-shield/C6.gif";
import Creator7 from "@/assets/gifs/creator-shield/C7.gif";
import Creator8 from "@/assets/gifs/creator-shield/C8.gif";
import Creator9 from "@/assets/gifs/creator-shield/C9.gif";
import { useLocation } from "react-router-dom";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function SocialProof() {
  const contentRef = useScrollAnimation({ threshold: 0.2 });
  const location = useLocation();
  const isLivePage = location.pathname.includes("/live");
  const backgroundColor = isLivePage ? "#9146FF" : "#FF6B35";

  const mobileCircles = [
    {
      image: Creator4,
      size: 200,
      left: "calc(50% - 140px)",
      top: "-120px",
      md: {
        size: 250, 
        left: "calc(50% - 300px)", 
        top: "-120px", 
      },
    },
    {
      image: Creator1,
      size: 115,
      left: "calc(50% + 160px)",
      top: "-10px",
      md: {
        size: 150,
        left: "calc(50% + 350px)",
        top: "-10px",
      },
    },
    {
      image: Creator3,
      size: 110,
      left: "calc(50% - 150px)",
      top: "1085px",
      md: {
        size: 160,
        left: "calc(50% - 350px)",
        top: "900px",
      },
    },
    {
      image: Creator9,
      size: 190,
      left: "calc(50% + 130px)",
      top: "1100px",
      md: {
        size: 280,
        left: "calc(50% + 290px)",
        top: "1050px",
      },
    },
  ];

  // Decorative circular elements (profile pictures) positioned around the text
  // Each circle has responsive positions for lg, xl, 1xl, and 2xl breakpoints
  const decorativeCircles = [
    {
      image: Creator1,
      size: 250,
      left: {
        lg: "calc(50% - 550px)",
        xl: "calc(50% - 690px)",
        "1xl": "calc(50% - 850px)",
        "2xl": "calc(50% - 820px)",
      },
      top: { lg: "-120px", xl: "-120px", "1xl": "-120px", "2xl": "-120px" },
    },
    {
      image: Creator2,
      size: 169,
      left: {
        lg: "calc(50% - 250px)",
        xl: "calc(50% - 310px)",
        "1xl": "calc(50% - 340px)",
        "2xl": "calc(50% - 372.5px)",
      },
      top: { lg: "10px", xl: "-10px", "1xl": "30px", "2xl": "30px" },
    },
    {
      image: Creator3,
      size: 135,
      left: {
        lg: "calc(50% + 80px)",
        xl: "calc(50% + 50px)",
        "1xl": "calc(50% + 110px)",
        "2xl": "calc(50% + 119px)",
      },
      top: { lg: "0px", xl: "-40px", "1xl": "-40px", "2xl": "-40px" },
    },
    {
      image: Creator4,
      size: 270,
      left: {
        lg: "calc(50% + 300px)",
        xl: "calc(50% + 300px)",
        "1xl": "calc(50% + 425px)",
        "2xl": "calc(50% + 470px)",
      },
      top: { lg: "-120px", xl: "-130px", "1xl": "-140px", "2xl": "-120px" },
    },
    {
      image: Creator5,
      size: 250,
      left: {
        lg: "calc(50% + 450px)",
        xl: "calc(50% + 570px)",
        "1xl": "calc(50% + 600px)",
        "2xl": "calc(50% + 650px)",
      },
      top: { lg: "300px", xl: "300px", "1xl": "250px", "2xl": "270px" },
    },
    {
      image: Creator6,
      size: 350,
      left: {
        lg: "calc(50% - 650px)",
        xl: "calc(50% - 800px)",
        "1xl": "calc(50% - 920px)",
        "2xl": "calc(50% - 940px)",
      },
      top: { lg: "640px", xl: "600px", "1xl": "600px", "2xl": "570px" },
    },
    {
      image: Creator7,
      size: 179,
      left: {
        lg: "calc(50% + 10px)",
        xl: "calc(50% + 20px)",
        "1xl": "calc(50% + 20px)",
        "2xl": "calc(50% + 20px)",
      },
      top: { lg: "750px", xl: "730px", "1xl": "720px", "2xl": "740px" },
    },
    {
      image: Creator8,
      size: 320,
      left: {
        lg: "calc(50% + 350px)",
        xl: "calc(50% + 400px)",
        "1xl": "calc(50% + 500px)",
        "2xl": "calc(50% + 500px)",
      },
      top: { lg: "650px", xl: "650px", "1xl": "670px", "2xl": "670px" },
    },
    {
      image: Creator9,
      size: 180,
      left: {
        lg: "calc(50% - 250px)",
        xl: "calc(50% - 280px)",
        "1xl": "calc(50% - 360px)",
        "2xl": "calc(50% - 320px)",
      },
      top: { lg: "760px", xl: "750px", "1xl": "750px", "2xl": "750px" },
    },
  ];

  return (
    <div
      className="py-20 px-6 md:px-16 relative overflow-hidden"
      style={{ backgroundColor }}
    >
      <div className={`4xl:max-w-[100rem] 4xl:mx-auto relative ${isLivePage ? 'h-[1100px]' : 'h-[1200px]'} lg:h-[750px] flex items-center justify-center`}>
        {/* Main Content */}
        <div ref={contentRef} className="flex flex-col gap-8 md:gap-9 items-center text-center text-white max-w-[1180px] mx-auto relative z-10 animate-fade-rise">
          <p className="font-semibold text-xl uppercase tracking-wide">
            SOCIAL PROOF
          </p>
          <h2 className="text-5xl lg:text-6xl font-semibold max-w-52 lg:max-w-full leading-normal">
            Trusted by Epic Creators
          </h2>
          <div className={`text-2xl md:text-3xl ${isLivePage ? 'max-w-4xl' : 'max-w-1xl'} leading-[49px]`}>
            {isLivePage ? (
              <>
                <p className="mb-0">
                  We started by simply helping video creators protect their rights
                  and content. With over $50-million recouped since launch, they did
                  immensely well.
                </p>
                <p className="mb-0">&nbsp;</p>
                <p>
                  Now, we're expanding our service to top streamers & broadcasters.
                </p>
              </>
            ) : (
              <>
                <p className="mb-0 ">
                  CreatorShield is trusted by leading creators and media companies to protect their content and earnings at scale. Since launch, we've successfully recouped over $50 million in lost ad revenue by identifying stolen uploads and enforcing monetization rights across major platforms.
                </p>
                <p className="mb-0">&nbsp;</p>
                <p>
                  From individual creators to large media brands, CreatorShield delivers proven, measurable results.
                </p>
              </>
            )}
          </div>
        </div>

        {/* Decorative Circular Elements - Desktop */}
        {decorativeCircles.map((circle, index) => {
          // Calculate responsive sizes (2xl stays at original size)
          const responsiveSize = {
            lg: Math.round(circle.size * 0.7),
            xl: Math.round(circle.size * 0.85),
            "1xl": Math.round(circle.size * 0.95),
            "2xl": circle.size,
          };

          // Get left value with fallback for circles that don't have 1xl defined
          const getLeft = (breakpoint) => {
            if (circle.left[breakpoint]) {
              return circle.left[breakpoint];
            }
            // Fallback: use 2xl if 1xl not defined
            if (breakpoint === "1xl") {
              return circle.left["2xl"] || circle.left.xl;
            }
            return circle.left[breakpoint];
          };

          // Get top value with fallback for circles that don't have 1xl defined
          const getTop = (breakpoint) => {
            if (circle.top[breakpoint]) {
              return circle.top[breakpoint];
            }
            // Fallback: use 2xl if 1xl not defined
            if (breakpoint === "1xl") {
              return circle.top["2xl"] || circle.top.xl;
            }
            return circle.top[breakpoint];
          };

          return (
            <div key={index}>
              <style>{`
                #circle-${index} {
                  width: ${responsiveSize.lg}px;
                  height: ${responsiveSize.lg}px;
                  left: ${circle.left.lg};
                  top: ${circle.top.lg};
                }
                @media (min-width: 1280px) {
                  #circle-${index} {
                    width: ${responsiveSize.xl}px !important;
                    height: ${responsiveSize.xl}px !important;
                    left: ${circle.left.xl} !important;
                    top: ${circle.top.xl} !important;
                  }
                }
                @media (min-width: 1440px) {
                  #circle-${index} {
                    width: ${responsiveSize["1xl"]}px !important;
                    height: ${responsiveSize["1xl"]}px !important;
                    left: ${getLeft("1xl")} !important;
                    top: ${getTop("1xl")} !important;
                  }
                }
                @media (min-width: 1536px) {
                  #circle-${index} {
                    width: ${responsiveSize["2xl"]}px !important;
                    height: ${responsiveSize["2xl"]}px !important;
                    left: ${circle.left["2xl"]} !important;
                    top: ${circle.top["2xl"]} !important;
                  }
                }
              `}</style>
              <div
                id={`circle-${index}`}
                className="absolute rounded-full overflow-hidden hidden lg:block float-animation"
                style={{ animationDelay: `${index * 0.5}s` }}
              >
                <img
                  src={circle.image}
                  alt=""
                  className="w-full h-full object-cover rounded-full"
                />
              </div>
            </div>
          );
        })}

        {/* Mobile Images - Customizable positions and sizes */}
        <div className="lg:hidden absolute w-full h-full left-0 top-0 pointer-events-none overflow-visible">
          {mobileCircles.map((circle, index) => (
            <div key={`mobile-${index}`}>
              <style>{`
                #mobile-circle-${index} {
                  width: ${circle.size}px;
                  height: ${circle.size}px;
                  left: ${circle.left};
                  top: ${circle.top};
                }
                @media (min-width: 768px) {
                  #mobile-circle-${index} {
                    width: ${circle.md?.size || circle.size}px !important;
                    height: ${circle.md?.size || circle.size}px !important;
                    left: ${circle.md?.left || circle.left} !important;
                    top: ${circle.md?.top || circle.top} !important;
                  }
                }
              `}</style>
              <div
                id={`mobile-circle-${index}`}
                className="absolute rounded-full overflow-hidden float-animation-centered"
                style={{ animationDelay: `${index * 0.5}s` }}
              >
                <img
                  src={circle.image}
                  alt=""
                  className="w-full h-full object-cover rounded-full"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
